import React, { Component } from "react";
import NavBar from "../components/NavBar";
import Sidebar from "./components/Sidebar";
import ServiceGallery from "./components/ServiceGallery"
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
class ParentCounselling extends Component {
  render() {
    return (
      <div>
        {/* Navigation bar */}
        <NavBar />

        {/* breadcrumb */}
        {/*====================  breadcrumb area ====================*/}
        <div
          className="breadcrumb-area breadcrumb-bg"
          style={{
            backgroundImage: `url(assets/img/backgrounds/funfact-bg.jpg)`
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col">
                <div className="page-banner text-center">
                  <h1>Parent Counselling & Guidance</h1>
                  <ul className="page-breadcrumb">
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li>
                      <a href={`${process.env.PUBLIC_URL}/services`}>
                        Services
                      </a>
                    </li>
                    <li>Parent Counselling & Guidance</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*====================  End of breadcrumb area  ====================*/}

        <div className="page-wrapper section-space--inner--120">
          {/*Service section start*/}
          <div className="service-section">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 col-12 order-1 order-lg-2">
                  <div className="service-details">
                    {/* service gallery */}
                    <ServiceGallery />

                    <div className="content section-space--top--30">
                      <h2>Parent Counselling & Guidance</h2>

                      <p>
                        Parents play the most important role in a child’s growth and development. Raising a child with developmental delays, learning difficulties, behavioural concerns, or communication challenges can often bring questions, uncertainty, and emotional stress. Parent Counselling and Guidance is designed to empower families with the knowledge, confidence, and practical skills needed to support their child’s development effectively.
                      </p>
                      <p>
                        Our counselling sessions provide a safe, supportive, and non-judgmental environment where parents can openly discuss their concerns, understand their child’s strengths and challenges, and receive professional guidance tailored to their family’s needs. The focus is on helping parents better understand their child’s developmental journey while equipping them with practical strategies that can be easily incorporated into daily routines.
                      </p>

                      <h3 className="section-space--top--50">How We Support Families</h3>

                      <p>
                        Parents are guided on topics such as behaviour management, communication techniques, learning support at home, emotional regulation, social skill development, daily living routines, and positive parenting practices. Counselling also helps families understand the goals of therapy, monitor their child’s progress, and actively participate in the intervention process. By strengthening collaboration between parents and professionals, children receive consistent support across home, school, and therapy settings, leading to better developmental outcomes.
                      </p>
                      <p>
                        Every family is unique, and our approach respects individual values, circumstances, and parenting styles. We believe that informed and confident parents become strong partners in their child’s growth, creating a nurturing environment where children feel supported, encouraged, and motivated to succeed.
                      </p>

                      <h3 className="section-space--top--50">Conclusion</h3>
                      <p>
                        At Shakuntla Learn and Fly Foundation, we believe that empowering parents is essential to empowering children. Through compassionate counselling, professional guidance, and family-centred support, we help parents build the confidence and skills needed to nurture their child’s development. Together, we create a strong partnership that enables every child to grow, learn, and reach their fullest potential in a caring and supportive environment.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-12 order-2 order-lg-1">
                  <Sidebar />
                </div>
              </div>
            </div>
          </div>
          {/*Service section end*/}
        </div>

        {/* Footer */}
        <Footer />

        {/* Mobile Menu */}
        <MobileMenu />
      </div>
    );
  }
}

export default ParentCounselling;
